import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';

import { useBreadcrumbs } from 'hooks';
import { getCurrentCurrency } from 'selectors';
import { getLocaleUrlPath } from 'utils';

import BreadCrumbs from 'components/BreadCrumbs';

const CurrencyYearArchiveBreadCrumbs = () => {
  const location = useLocation();
  const { currency, year } = useParams();
  const { locale, formatMessage } = useIntl();

  const currentCurrency = useSelector(state =>
    getCurrentCurrency(state, { currency })
  );

  const currencyLabel =
    currentCurrency?.nameG || currentCurrency?.name || currency?.toUpperCase();

  const localeInURL = getLocaleUrlPath(locale);
  const routerBasename = `${localeInURL}${process.env.APP_ROUTER_BASENAME}`;

  const currentPageTitle = formatMessage(
    { id: 'currencyYearArchivePage.title' },
    {
      currency: currencyLabel,
      year,
    }
  );

  const breadcrumbsPlaceholders = useMemo(
    () => [
      {
        name: formatMessage({ id: 'breadcrumbs.mainPage' }),
        link: getLocaleUrlPath(locale),
      },
      {
        name: formatMessage({ id: 'breadcrumbs.currencyPage' }),
        link: routerBasename,
      },
      {
        name: currentPageTitle,
        link: `${routerBasename}${location.pathname}`,
      },
    ],
    [currentPageTitle, formatMessage, locale, location.pathname, routerBasename]
  );

  const breadcrumbs = useBreadcrumbs(breadcrumbsPlaceholders);

  return breadcrumbs.length ? <BreadCrumbs breadcrumbs={breadcrumbs} /> : null;
};

export default memo(CurrencyYearArchiveBreadCrumbs);
